import { SearchOption } from '@broker-crm-hooks/useGlobalSearch';

import { Maybe, MortgageReason, SearchResultCase } from '@acre/graphql'

import { DEFAULT_EMPTY_OPTION } from './GlobalSearchOption'

export const getProductTypeIntl = (reason: MortgageReason): string => {
  return `productTypes.${STATUS_INTL[reason as keyof typeof STATUS_INTL]}`
}

const STATUS_INTL = {
  [MortgageReason.ReasonFtb]: 'firstTimeBuy',
  [MortgageReason.ReasonHouseMove]: 'houseMove',
  [MortgageReason.ReasonRemortgage]: 'remortgage',
  [MortgageReason.ReasonBtl]: 'buyToLet',
  [MortgageReason.ReasonBtlRemortgage]: 'buyToLetRemortgage',
  [MortgageReason.ReasonEquityRelease]: 'equityRelease',
  [MortgageReason.ReasonFurtherAdvance]: 'furtherAdvance',
  [MortgageReason.ReasonBusinessProtection]: 'businessProtection',
  [MortgageReason.ReasonProtection]: 'protection',
  [MortgageReason.InvalidMortgageReason]: 'noReasonProvided',
  [MortgageReason.ReasonCommercial]: 'commercial',
  [MortgageReason.ReasonBridging]: 'bridging',
  [MortgageReason.ReasonGeneralInsurance]: 'homeInsurance',
}

/**
 * Generates a URL for a specific item (either client or individual case)
 */
export const getUrlForOption = (option: SearchOption) => {
  if (!option || !option.id) return ''

  if (option.doctype === "client") return `/clients/${option.id}/overview`
  if (option.doctype === "client_case") {
    // Solr uses composite IDs to prevent parent/child ID conflicts
    // Format: clientId_caseId - extract the case portion
    const caseId = option.id.split("_")[1]
    return `/cases/${caseId}/overview`
  }

  return ""
}


export const getName = (orgName: Maybe<string>, firstName: Maybe<string>, lastName: Maybe<string>) => {
  if (orgName) return orgName

  if (firstName && lastName) return `${firstName} ${lastName}`
  if (firstName) return firstName
  if (lastName) return lastName

  return DEFAULT_EMPTY_OPTION
}

export const getDisplayedProperty = (caseItem: SearchResultCase) => {
  const parts = [caseItem.address1, caseItem.town, caseItem.postcode].filter((part) => part && part.trim())

  return parts.length > 0 ? parts.join(', ') : DEFAULT_EMPTY_OPTION
}